import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";

interface InputFieldProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "type"
> {
  label?: ReactNode;
  helperText?: string;
  error?: string;
  type?:
    | "text"
    | "email"
    | "password"
    | "number"
    | "tel"
    | "url"
    | "search"
    | "date"
    | "time"
    | "datetime-local";
  className?: string;
  inputClassName?: string;
}

export const InputField = forwardRef<HTMLInputElement, InputFieldProps>(
  (
    {
      label,
      helperText,
      error,
      type = "text",
      className = "",
      inputClassName = "",
      ...inputProps
    },
    ref,
  ) => {
    return (
      <div className={`space-y-2 ${className}`.trim()}>
        {label && (
          <label className="text-label" htmlFor={inputProps.id}>
            {label}
          </label>
        )}
        <input
          ref={ref}
          type={type}
          className={`input-compact w-full ${inputClassName}`.trim()}
          {...inputProps}
        />
        {helperText && !error && (
          <p className="text-size-2xs text-global-tertiary">{helperText}</p>
        )}
        {error && <p className="text-size-2xs text-global-error">{error}</p>}
      </div>
    );
  },
);

InputField.displayName = "InputField";
